import classNames from 'classnames';
import { useRouter } from 'next/router';
import Image from 'next/image';

import TextBlock from '../TextBlock/TextBlock';
import LinkNumbers from '../LinkNumbers/LinkNumbers';

import styles from './ProductStatus.module.scss';

const StatusTable = ({ dataItem, dark }) => {
  const renderLinkOrText = (ussd) => {
    if (ussd) {
      return <LinkNumbers numbers={ussd} dark={dark} isTel={true} />;
    }

    return (
      <span className={styles['status-item__value']}>{dataItem?.text}</span>
    );
  };

  return (
    <div
      className={classNames([styles['status-item'], 'status-item'])}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles['status-item__content']}>
        <div className={styles['status-item__img']}>
          {dataItem?.icon && (
            <Image
              className={styles['status-item__icon']}
              src={dataItem?.icon}
              alt={dataItem?.title}
              title={dataItem?.title}
              loading='lazy'
              width={32}
              height={32}
            />
          )}
          {dataItem?.title && (
            <strong className={classNames(styles['status-item__key'])}>
              {dataItem?.title}
            </strong>
          )}
        </div>
        <div className={styles.ussdCode}>
          {dataItem?.right_text && (
            <strong className={classNames(styles['status-item__key'])}>
              {dataItem?.right_text}
            </strong>
          )}
          <div>{renderLinkOrText(dataItem?.ussd?.join(''))}</div>
        </div>
      </div>
    </div>
  );
};

const ProductStatus = ({ statusData, className, isBlock, dark = false }) => {
  const router = useRouter();
  const isBusiness = router.asPath.startsWith('/business');
  const renderStatusItems = (item, index) => {
    return <StatusTable dark={dark} dataItem={item} key={index} />;
  };
  return (
    <div
      className={classNames([styles['product-status'], className])}
      itemScope
      itemType='https://schema.org/Product'
    >
      <div
        className={classNames([
          styles['product-status__inner'],
          { [styles['product-status__inner--block']]: isBlock },
        ])}
      >
        <div className={styles['product-status__content']}>
          {/* {statusData?.title && (
            <SectionTitle
              titleModify={titleModify}
              className={styles['product-status__title']}
              Icon={Icon}
            >
              {statusData?.title}
            </SectionTitle>
          )} */}

          {statusData?.description && (
            <TextBlock
              isHtml
              className={classNames(
                'text--large',
                styles['product-status__text'],
              )}
            >
              {statusData?.description}
            </TextBlock>
          )}
        </div>
        {statusData?.sections?.length > 0 && (
          <div
            className={classNames([
              styles['product-status__table'],
              'product-status__table',
              { [styles.productStatusTableBusiness]: isBusiness },
            ])}
          >
            {statusData?.sections?.map(renderStatusItems)}
          </div>
        )}
        <div className={styles.bottomContent}>
          {/* {statusData?.text2 && ( */}
          <TextBlock
            isHtml
            className={classNames(
              'text--large',
              styles['product-status__text'],
            )}
          >
            {statusData?.text2}
          </TextBlock>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default ProductStatus;
